<script>
    import {t} from '$utils/lang.js';
    import {untrack} from 'svelte';

    const PHONE_REGEX = /\+?[\d\s\-/()]{6,}/;

    let {
        paymentId,
        metadata,
        onReady = (_birthdate, _phone, _cmid) => {},
        onClear = () => {},
        initialBirthdate = '',
        initialPhone = '',
    } = $props();

    // state_referenced_locally: state-seed liest die Initial-Werte einmal
    // aus den Props. untrack() macht klar dass wir die Prop nicht "tracken"
    // wollen — Re-Mount via key={} wenn Parent die Werte ändern will.
    let birthdate = $state(untrack(() => initialBirthdate));
    let phone = $state(untrack(() => initialPhone));
    let bdError = $state('');
    let phoneError = $state('');
    let cmid = $state('');
    let sdkLoading = $state(true);

    $effect(() => {
        initFraudnet();
    });

    async function initFraudnet() {
        // Remove any previous Fraudnet scripts so re-init is clean
        document.querySelectorAll('script[fncls="fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99"]').forEach(s => s.remove());
        document.querySelectorAll('script[src="https://c.paypal.com/da/r/fb.js"]').forEach(s => s.remove());

        const sessionId = crypto.randomUUID();

        const configScript = document.createElement('script');
        configScript.type = 'application/json';
        configScript.setAttribute('fncls', 'fnparams-dede7cc5-15fd-4c75-a9f4-36c430ee3a99');
        const config = {f: sessionId, s: 'Oxid_PayPal_PUI_Checkout'};
        if (metadata?.sandbox) config.sandbox = true;
        configScript.textContent = JSON.stringify(config);
        document.head.appendChild(configScript);

        const fraudnetScript = document.createElement('script');
        fraudnetScript.src = 'https://c.paypal.com/da/r/fb.js';
        fraudnetScript.charset = 'UTF-8';
        document.head.appendChild(fraudnetScript);

        // Wait for Fraudnet to call home before allowing order placement
        await new Promise(r => setTimeout(r, 2000));

        cmid = sessionId;
        sdkLoading = false;
        tryEmitReady();
    }

    function isValidDate(val) {
        if (!/^\d{4}-\d{2}-\d{2}$/.test(val)) return false;
        const d = new Date(val);
        if (isNaN(d.getTime())) return false;
        const minAge = new Date();
        minAge.setFullYear(minAge.getFullYear() - 18);
        return d <= minAge;
    }

    function tryEmitReady() {
        if (isValidDate(birthdate) && PHONE_REGEX.test(phone)) {
            onReady(birthdate, phone, cmid);
        } else {
            onClear();
        }
    }

    function handleBdChange(e) {
        birthdate = e.target.value;
        bdError = '';
        if (birthdate && !isValidDate(birthdate)) {
            bdError = t('Bitte gib ein gültiges Geburtsdatum ein (mind. 18 Jahre).');
        }
        tryEmitReady();
    }

    function handlePhoneChange(e) {
        phone = e.target.value;
        phoneError = '';
        if (phone && !PHONE_REGEX.test(phone)) {
            phoneError = t('Bitte gib eine gültige Telefonnummer ein (z.B. +49 30 123456789).');
        }
        tryEmitReady();
    }
</script>

<div class="space-y-3">
    <p class="text-sm text-gray-103">
        {t('Für die Abwicklung des Rechnungskaufes benötigen wir dein Geburtsdatum sowie eine gültige Telefonnummer mit Orts- oder Ländervorwahl (z.B. 030 123456789 oder +49 30 123456789).')}
    </p>

    <div>
        <label class="block text-xs text-gray-103 mb-1" for="pui-birthdate">
            {t('Geburtstag')}
        </label>
        <input
            id="pui-birthdate"
            type="date"
            autocomplete="bday"
            value={birthdate}
            onchange={handleBdChange}
            max={new Date(new Date().setFullYear(new Date().getFullYear() - 18)).toISOString().split('T')[0]}
            class="w-full h-10 px-3 border rounded-md text-sm bg-white focus:outline-none focus:ring-1 focus:ring-cyprus
                {bdError ? 'border-scarlet' : 'border-grey'}"
        />
        {#if bdError}
            <p class="text-scarlet text-xs mt-1">{bdError}</p>
        {/if}
    </div>

    <div>
        <label class="block text-xs text-gray-103 mb-1" for="pui-phone">
            {t('Telefonnr.')}
        </label>
        <input
            id="pui-phone"
            type="tel"
            autocomplete="tel"
            value={phone}
            oninput={handlePhoneChange}
            placeholder="+49 30 123456789"
            class="w-full h-10 px-3 border rounded-md text-sm bg-white focus:outline-none focus:ring-1 focus:ring-cyprus
                {phoneError ? 'border-scarlet' : 'border-grey'}"
        />
        {#if phoneError}
            <p class="text-scarlet text-xs mt-1">{phoneError}</p>
        {/if}
    </div>

    {#if sdkLoading}
        <p class="text-xs text-gray-103">{t('Wird geladen…')}</p>
    {/if}

    <p class="text-xs text-gray-103 leading-relaxed">
        {t('Mit Klicken auf den "Jetzt kaufen"-Button akzeptierst du die')}&nbsp;<a href="https://www.ratepay.com/legal-payment-terms" target="_blank" rel="noopener" class="font-bold underline">{t('Ratepay Zahlungsbedingungen')}</a>&nbsp;{t('und erklärst dich mit der Durchführung einer')}&nbsp;<a href="https://www.ratepay.com/legal-payment-dataprivacy" target="_blank" rel="noopener" class="font-bold underline">{t('Risikoprüfung durch Ratepay')}</a>,&nbsp;{t('unseren Partner, einverstanden. Du akzeptierst auch')}&nbsp;<a href="https://www.paypal.com/de/webapps/mpp/ua/rechnungskauf-mit-ratepay?locale.x=de_DE" target="_blank" rel="noopener" class="font-bold underline">{t('PayPals Datenschutzerklärung')}</a>.&nbsp;{t('Falls deine Transaktion per Kauf auf Rechnung erfolgreich abgewickelt werden kann, wird der Kaufpreis an Ratepay abgetreten und du darfst nur an Ratepay überweisen, nicht an den Händler.')}
    </p>
</div>
